module.exports = __webpack_public_path__ + "files/5d97071096494f0a2f8c8364fdd1c9f4.png";